import { SUM } from '../types';
export default {
  type: SUM,
  service: 'rpc.solidum.network',
  url: 'https://rpc.solidum.network',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
